/**
 * <gr-fuel-card>
 * Wraps a Fuel Deck card and toggles `is-flipped` on click + Enter/Space.
 * Hover-flip is CSS-only (see gr-fuel-deck.css). Touch/keyboard goes through here.
 *
 * Attributes (set by Liquid):
 *   data-interactive  "true" | "false"   — when "false", clicks/keys are ignored
 *   data-rarity       "common"...        — for CSS targeting only
 *   tabindex, role, aria-label           — set by Liquid for accessibility
 *
 * State:
 *   .is-flipped class toggles the back face. Also flips aria-pressed.
 */

class GrFuelCard extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    if (this.dataset.interactive === 'false') return;
    const { signal } = this.#controller;
    this.addEventListener('click', this.#handleClick, { signal });
    this.addEventListener('keydown', this.#handleKeydown, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleClick = (event) => {
    // Don't flip if the click landed on a real link or button inside the card
    if (event.target.closest('a, button')) return;
    this.#toggle();
  };

  #handleKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target.closest('a, button')) return;
    event.preventDefault();
    this.#toggle();
  };

  #toggle() {
    const flipped = this.classList.toggle('is-flipped');
    this.setAttribute('aria-pressed', flipped ? 'true' : 'false');
  }
}

if (!customElements.get('gr-fuel-card')) {
  customElements.define('gr-fuel-card', GrFuelCard);
}
